export enum ActivePage {
	CHOOSE_HEROES = 'Choose Heroes',
	CHOOSE_CHAPTERS = 'Choose Chapters',
	KTO_OTEC = 'Kto otec',
}
